import React from 'react'
import { Link } from 'react-router-dom'


export function Footer() {
  return (
    <footer className="w-full bg-gray-950 text-white pt-16 pb-8 mt-auto border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img
                src="/images/lettrage_2.svg"
                alt="greenmango"
                className="h-8 w-auto"
              />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6 font-['Roboto']">
              AI services that work for you. Build products faster, adopt AI
              securely, and train your teams effectively.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/company/green-mango/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary transition-colors"
                aria-label="LinkedIn"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/g.r.e.e.n.m.a.n.g.o"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary transition-colors"
                aria-label="Instagram"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 016.11 2.525c.636-.247 1.363-.416 2.427-.465C8.83 2.012 9.185 2 11.615 2h.08zm-.08 1.802h-.63c-2.37 0-2.71.01-3.67.054-1.01.046-1.56.21-1.93.348-.48.18-.82.395-1.18.755a3.1 3.1 0 00-.755 1.18c-.138.37-.302.92-.348 1.93-.044.96-.054 1.3-.054 3.67v.63c0 2.37.01 2.71.054 3.67.046 1.01.21 1.56.348 1.93.18.48.395.82.755 1.18.36.36.7.575 1.18.755.37.138.92.302 1.93.348.96.044 1.3.054 3.67.054h.63c2.37 0 2.71-.01 3.67-.054 1.01-.046 1.56-.21 1.93-.348.48-.18.82-.395 1.18-.755.36-.36.575-.7.755-1.18.138-.37.302-.92.348-1.93.044-.96.054-1.3.054-3.67v-.63c0-2.37-.01-2.71-.054-3.67-.046-1.01-.21-1.56-.348-1.93-.18-.48-.395-.82-.755-1.18a3.1 3.1 0 00-1.18-.755c-.37-.138-.92-.302-1.93-.348-.96-.044-1.3-.054-3.67-.054zm0 3.24a4.958 4.958 0 100 9.916 4.958 4.958 0 000-9.916zm0 1.802a3.156 3.156 0 110 6.312 3.156 3.156 0 010-6.312zm4.99-1.148a1.152 1.152 0 100 2.304 1.152 1.152 0 000-2.304z" />
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-6 uppercase tracking-wider text-gray-300 font-['Poppins']">
              Services
            </h4>
            <ul className="space-y-4">
              <li>
                <Link to="/product-building" className="text-gray-400 hover:text-white text-sm transition-colors font-['Roboto']">
                  Product building
                </Link>
              </li>
              <li>
                <Link to="/consulting" className="text-gray-400 hover:text-white text-sm transition-colors font-['Roboto']">
                  Consulting
                </Link>
              </li>
              <li>
                <Link to="/training" className="text-gray-400 hover:text-white text-sm transition-colors font-['Roboto']">
                  Training
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-6 uppercase tracking-wider text-gray-300 font-['Poppins']">
              Company
            </h4>
            <ul className="space-y-4">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white text-sm transition-colors font-['Roboto']">
                  Home
                </Link>
              </li>
              {/* <li>
                <button className="text-gray-400 hover:text-white text-sm transition-colors font-['Roboto'] text-left">
                  About us
                </button>
              </li> */}
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-colors font-['Roboto']">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* <div className="lg:col-span-1">
            <h4 className="text-sm font-semibold mb-6 uppercase tracking-wider text-gray-300 font-['Poppins']">
              Stay updated
            </h4>
            <p className="text-gray-400 text-sm mb-4 font-['Roboto']">
              Subscribe to our newsletter for the latest AI insights.
            </p>
             <form className="flex flex-col gap-2" onSubmit={(e) => e.preventDefault()}>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <MailIcon className="h-5 w-5 text-gray-500" />
                </div>
                <input
                  type="email"
                  className="block w-full pl-10 pr-3 py-2 border border-gray-700 rounded-md leading-5 bg-gray-800 text-gray-300 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary sm:text-sm transition-colors"
                  placeholder="Enter your email"
                />
              </div>
              <button
                type="submit"
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-navy focus:ring-primary transition-colors"
              >
                Subscribe
              </button>
            </form> 
          </div> */}
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-sm text-gray-500 font-['Roboto']">
            &copy; {new Date().getFullYear()} greenmango. All rights reserved.
          </div>
          <div className="flex gap-6 text-sm text-gray-500 font-['Roboto']">
            <button className="hover:text-white transition-colors">Privacy Policy</button>
            <button className="hover:text-white transition-colors">Terms of Service</button>
          </div>
        </div>
      </div>
    </footer>
  )
}